import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { PDFDocument, rgb } from 'pdf-lib';
import BlankCertificate from '../../img/Certificate of Paricipation Impact Director.png'

import BlankCertificateTurkiye from '../../img/Impact Directors For participantion.png'
import axios from 'axios';
import fontkit from '@pdf-lib/fontkit'
import FontAbhaya from '../../AbhayaLibre-SemiBold.ttf'
import RobotoBold from '../../Roboto-Bold.ttf'
import AbhayaRegular from '../../AbhayaLibre-Regular.ttf'
import GoodVibrations from '../../GoodVibrations Script.ttf'
import PoppinsRegular from '../../Poppins-Regular.ttf'
import AbhayaBold from '../../AbhayaLibre-Bold.ttf'

import QRCode from 'qrcode'
import { useSelector } from 'react-redux';
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { Document, Page, Text, View, StyleSheet,PDFViewer, Image, Font,PDFDownloadLink, } from '@react-pdf/renderer';
import moment from "moment";

const ImpactDirectorCertificate = () => {

    var userEmail;
    var JSToken;
  var accessToken;
  if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  const [currentEventRegisteration, setCurrentEventRegisteration]=useState(null);
  const {eventId,delegateId}= useParams();
  const [qrUriImageFile,setqrUriImageFile]= useState(null);
  const [fontSize,setFontSize]= useState(44);
  const [eventDetails,setEventDetails]= useState(null);
  const [fullNameTop,setFullNameTop]= useState(375);
  const [lowerViewTop,setLowerViewTop]= useState(137);
  const [completeDateTop,setCompleteDateTop]= useState(415.0);

    Font.register({
        family:'AbhayaLibreSemiBold',
        src:FontAbhaya
      });
    Font.register({
        family:'RobotoBold',
        src:RobotoBold
      });
    Font.register({
        family:'AbhayaRegular',
        src:AbhayaRegular
      });
    Font.register({
        family:'AbhayaBold',
        src:AbhayaBold
      }); Font.register({
        family:'GoodVibrations',
        src:GoodVibrations
      });Font.register({
        family:'PoppinsRegular',
        src:PoppinsRegular
      });
      const styles = StyleSheet.create({
        page: {
          
        },
        section: {
          margin: 10,
          padding: 10,
          flexGrow: 1
        },viewer: {
          width: 870, 
          height: 690,
        },
        bgimages: {
          height:595,
          width:842,
          position: 'absolute'
        },title:{
            top:15,
            textAlign:'center',
            fontSize:58,
            color:'white',
          fontFamily:'AbhayaLibreSemiBold'
        },participation:{
            top:15,
            textAlign:'center',
            fontSize:21,
            color:'#F3D649',
          fontFamily:'RobotoBold'
        },initialline:{
            letterSpacing:1.5,
            top:210,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },showcase:{
            top:250,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'PoppinsRegular',
          marginHorizontal:144
        },complete:{
            top:250,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },completeDate:{
            top:completeDateTop,
            left:89.5,
            // textAlign:'center',
            fontSize:13,
            color:'#000000',
          fontFamily:'PoppinsRegular'
        },completeLocation:{
            top:250,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },fullname:{
            top:fullNameTop,
            textAlign:'center',
            fontSize:fontSize,
            textTransform: "capitalize",
            fontWeight: 'bold',
            color:'009EDC',
          fontFamily:'GoodVibrations'
        },headNameRight:{
            top:321,
            textAlign:'center',
            fontSize:16,
            color:'#4c8dcb',
          fontFamily:'AbhayaBold',
          
        },headNameLeft:{
            top:321,
            textAlign:'center',
            fontSize:16,
            color:'#4c8dcb',
          fontFamily:'AbhayaBold',
          marginLeft:18
        },headPositionRight:{
            top:318,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'RobotoBold',
          marginRight:45
          
        },headPositionLeft:{
            top:318,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'RobotoBold',
          marginLeft:55
        },lowerView:{
            top:lowerViewTop
        },
        QRImage:{
            top:490,
            left:390,
            position:'absolute',
            width:75}
        
      });

        // States
       
        const generateQR = async text => {
            try {
              return await QRCode.toDataURL(text,{
                color: {
                  dark: '009EDC',  // Blue dots
                  light: '#0000' // Transparent background
                }
              })
              
            } catch (err) {
              console.error(err)
            }
          } 
        
          //   Get User Registeration

      useEffect(() => {
        const fetchEventRegisteration = async () => {
            try {
              
              const result = await axios
                .get(
                  `https://dash.bestdiplomats.org/api/method/get-registration?event=${eventId}&delegate=${delegateId}`,config
                )
                .then((response) => {
                    setCurrentEventRegisteration(response.data.data)
                //   console.log(response.data.data);
                  if ((response.data.data.delegate_profile.user.first_name+response.data.data.delegate_profile.user.last_name).length > 25) {
                    setFontSize(38)
                    setFullNameTop(379.2)
                    setLowerViewTop(142)
                    setCompleteDateTop(421.5)
                  }else{
                    setFontSize(44)
                  }
                    
                   generateQR(`https://verify.bestdiplomats.org/verify/${response.data.data.delegate_profile.name}-${eventId}-${response.data.data.name}`).then((res)=>{
                    setqrUriImageFile(res);
                   }); 
                    
                  
                });
              
            } catch (e) {
              
              console.log(e);
            }
          };
          fetchEventRegisteration();
        
      }, []);

    useEffect(() => {
        const fetchEvent= async () => {
            try {
              
              const result = await axios
                .get(
                    "https://dash.bestdiplomats.org/api/resource/Events/" + eventId
                )
                .then((response) => {
                    setEventDetails(response.data.data)
                  
                });
              
            } catch (e) {
              
              console.log(e);
            }
          };
          fetchEvent();
        
      }, []);

  return (
    <div>
    <PDFDownloadLink document={ <Document>
        <Page size={[842,595]} >
        {eventId=="b50a010e23"?<Image src={BlankCertificateTurkiye} style={styles.bgimages}></Image>:<Image src={BlankCertificate} style={styles.bgimages}></Image>} 
    <Text style={styles.fullname}>{""}{""+(currentEventRegisteration?.delegate_profile.user.first_name.replace(/\n/g, "")?.toLowerCase())+" "+(currentEventRegisteration?.delegate_profile.user.last_name.replace(/\n/g, "")?.toLowerCase())}</Text>
    <View style={styles.lowerView}>
    <Text style={styles.showcase}>In recognition of your visionary thinking, strategic planning and innovative problem solving at {eventDetails?.title}.</Text>
    </View>
    <Text style={styles.completeDate}>{moment(eventDetails?.end_date).format("Do MMMM YYYY")}</Text>
    <Image source={qrUriImageFile} style={styles.QRImage}></Image>

    </Page>
  </Document>} fileName={`Invitation-${currentEventRegisteration?.delegate_profile.user.full_name}.pdf`}>
  {({ blob, url, loading, error }) =>
        loading ? ( <span className='group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'>Loading...</span>) : ( <span className='group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'>Download PDF</span>)
      }
  </PDFDownloadLink>

<PDFViewer style={styles.viewer}>
    <Document>
    <Page size={[842,595]} >
   {eventId=="b50a010e23"?<Image src={BlankCertificateTurkiye} style={styles.bgimages}></Image>:<Image src={BlankCertificate} style={styles.bgimages}></Image>} 
  <Text style={styles.fullname}>{""}{""+(currentEventRegisteration?.delegate_profile.user.first_name.replace(/\n/g, "")?.toLowerCase())+" "+(currentEventRegisteration?.delegate_profile.user.last_name.replace(/\n/g, "")?.toLowerCase())}</Text>
    <View style={styles.lowerView}>
    <Text style={styles.showcase}>In recognition of your visionary thinking, strategic planning and innovative problem solving at {eventDetails?.title}.</Text>
   
    </View>
    <Text style={styles.completeDate}>{moment(eventDetails?.end_date).format("Do MMMM YYYY")}</Text>
    <Image source={qrUriImageFile} style={styles.QRImage}></Image>

    </Page>
  </Document>
  </PDFViewer>
    </div>
  )
}

export default ImpactDirectorCertificate